<template>
  <div id="mask1" style="background:#F1F4FA;border-top:2px solid #E2211C">
    <div class="qrcode">
      <div
        style="background-color:white;border:2px solid #ddd;padding:10px;display:inline-block;margin-bottom:10px;"
      >
        <qrcode-vue :value="src"  level="H"></qrcode-vue>
        <span>扫一扫,分享活动</span>
      </div>
    </div>
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe10.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe11.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe1.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe2.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe12.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe3.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe4.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe5.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe13.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe6.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe7.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe8.jpg'"
      alt
    />
    <img
      style="display:block;margin:0 auto"
      :src="serve + '/bannerAD/bannerInfo/cellsafe/cellsafe9.jpg'"
      alt
    />
    <div id="mask1">
      <div class="foot2">
        <div style="margin:0 auto;width:1200px;" class="clearfix">
          <div class="list" v-for="item in topic" :key="item.index">
            <router-link target="_blank" :to="'/product/'+item.id">
              <div class="list_img">
                <img :src="serve + '/' + item.images" alt />
              </div>
            </router-link>
            <div>
              <router-link target="_blank" :to="'/product/'+item.id">
                <div class="list_title">{{item.title}}</div>
              </router-link>
              <div class="list_info">
                <div class="share">
                  <!-- <img src="../../assets/images/share.png" alt=""> -->
                  <span class="share_bio">BioFlin</span>
                  <span class="share_text">精选</span>
                </div>
              </div>
              <div class="list_money">
                <div class="list_money1">
                  <div>￥{{item.selling_price}}</div>
                  <div>￥{{item.original_price}}</div>
                </div>
                <div class="list_car" @click="addcar(item.id)">
                  <i
                    class="fas fa-shopping-cart fa-lg"
                    style="color:#fff;font-size:24px;margin-left: 4px;"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- :class="{'ref_trans' : transfrom != true}" -->
        <div @click="refresh1()" class="refresh" :class="{'ref_trans' : transfrom1}">
          <i class="fas fa-sync-alt" style="color:#2AC2D2;font-size:35px"></i>
        </div>
        <!-- -->
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      serve: this.$store.state.serve,
      topic: [],
      topics: [],
      topics2: [],
      transfrom: true,
      transfrom1: false,
      src:"https://www.bioflin.com/#/banner_cellsafe"
    }
  },

  created() {
    this.geting()
  },
  watch: {},
  mounted() {},
  methods: {
    geting(e) {
      this.transfrom1 = true
      this.axios
        .get(this.serve + '/search', {
          params: {
            ThirdClass: 790,
            page: e
          }
        })
        .then(res => {
          this.topic = []
          this.transfrom1 = false
          var tab = res.data.results.concat()
          this.topic = tab
        })
    },
    refresh1() {
      if (this.transfrom == true) {
        this.geting(2)
        // this.topic = this.topics2;
        this.transfrom = false
      } else if (this.transfrom == false) {
        this.transfrom = true
        this.geting(1)
      }

      // if(this.transfrom == true){
      //   this.topic = this.topics
      //   this.transfrom = false
      // }else{
      //   this.geting()
      // }
      // var topics =  this.topic

      // if(this.transfrom == true){
      //   this.transfrom = false
      //   this.topic = this.topics
      // }else{
      //   console.log(1)
      //   this.topic = this.topics2
      // }
      // var topics1 = this.topic.splice(13,24)
    },
    addcar(id) {
      this.axios
        .get(this.serve + '/member/add_car', {
          params: {
            token: this.$cookies.get('token'),
            mobile: this.$cookies.get('user'),
            id: id,
            number: 1
          }
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.$message({
              type: 'success',
              message: '商品以加入购物车'
            })
          } else if (res.data.status == 'error') {
            this.$message({
              type: 'error',
              message: res.data.data
            })
          }
        })
    }
  }
}
</script>

<style lang="scss">
.clearfix:after {
  content: '';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#mask1 {
  position: relative;
  max-width: 100%;
  //   > img {
  //     width: 100%;
  //   }
  .qrcode {
    position: absolute;
    top: 50px;
    right: 150px;
  }
  .banner_posi {
    width: 1308px;
    height: 1109px;
    position: absolute;
    margin-left: -654px;
    left: 50%;
    top: 378px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .refresh {
    width: 35px;
    height: 35px;
    margin: 0 auto;
    cursor: pointer;
    // text-align: center;
    margin-top: 30px;
  }
  @keyframes ref_trans {
    0% {
      transform: rotate(0);
    }
    50% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0);
    }
  }

  .ref_trans {
    transition: 0.5s;
    transform-origin: 50% 50%;
    animation: rotate 0.5s linear infinite; /*开始动画后无限循环，用来控制ref_trans*/
  }

  // .ref_trans {
  //   transform: rotate(360deg);
  //   transition: 1s;
  // }

  .foot {
    width: 100%;
    background: #fff;
  }
  .foot1 {
    width: 100%;
    background: #dee3dd;
  }

  .foot2 {
    width: 100%;
    //  background: #b7edff;
    padding-top: 50px;
    padding-bottom: 100px;
  }
  .list {
    float: left;
    width: 595px;
    height: 280px;
    background: #fff;
    margin-right: 5px;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .list_img {
      width: 276px;
      height: 250px;
      // margin: 0 auto;
      padding-top: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .list_title {
      padding-top: 20px;
      width: 249px;
      height: 50px;
      overflow: hidden;
      margin: 0 auto;
      font-size: 17px;
      font-family: 'Microsoft YaHei';
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
      line-height: 26px;
    }
    .list_info {
      overflow: hidden;
      padding-top: 20px;
      // height: 118px;
      width: 249px;
      font-size: 16px;
      font-family: ' Source Han Sans CN';
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 24px;
      .share {
        //   position: absolute;
        //   left: 0;
        //   top: 0;
        margin-top: 4px;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
        .share_bio {
          background: rgba(226, 33, 28, 1);
          color: rgba(255, 255, 255, 1);
          font-family: 'DengXian-Bold';
          font-weight: bold;
          height: 12px;
          padding: 2px;
        }
        .share_text {
          background: rgba(40, 40, 40, 1);
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          height: 12px;
          padding: 2px;
          // padding-left: 4px;
        }
      }
    }
    .list_title:hover {
      color: #e2211c;
    }
    .list_money {
      display: flex;
      justify-content: space-between;
      width: 249px;
      margin: 16px auto;
      .list_money1 {
        display: flex;
        align-items: center;
        :nth-child(1) {
          font-size: 22px;
          font-weight: 400;
          color: rgba(246, 78, 98, 1);
        }
        :nth-child(2) {
          margin-left: 10px;
          font-size: 17px;
          font-weight: 400;
          text-decoration: line-through;
          color: rgba(153, 153, 153, 1);
        }
      }
      .list_car {
        display: flex;
        // justify-content: center;
        cursor: pointer;

        align-items: center;
        width: 37px;
        height: 37px;
        background: #2ac2d2;
        border-radius: 6px;
      }
    }
  }
}
</style>
